import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { from, Observable, of } from 'rxjs';
import { UserService } from '../services/user.service';
import { UserRoles } from '../../../models/User';

@Injectable({
  providedIn: 'root'
})
export class UserRoleResolver implements Resolve<UserRoles> {

  constructor(private userService: UserService) { }

  resolve(): Observable<UserRoles> {
    const role = this.userService.getLoggedUser()?.type;
    if (role) {
      return of(role);
    } else {
      return from(this.userService.saveLoggedUser().then(u => u.type));
    }
  }
}
